module.exports = __webpack_public_path__ + "img/brush.217aaa8f.svg";